// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	TENANT_ID: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
	CLIENT_ID: '9d822665-267a-4ec4-83e5-f1002b928b0e',
	REDIRECT_URL: 'https://alarms.qa.lios.toyota.com',
	apiUrl: "https://ts.stage.portal.toyotasupplier.com/liosop/alarmsapi",
	//liosUrl: 'https://ts.stage.portal.toyotasupplier.com/lios/index'
	liosUrl: 'https://qa.lios.toyota.com/',
	APM_DS_URI: 'https://api.qa.lios.toyota.com/apm/graphql',
	SCOPES: ['https://tmnatest.onmicrosoft.com/e45b42dc-670d-4640-b95b-a24d12e73448/user_impersonation'],
  	AG_GRID_CONFIG:'Using_this_{AG_Grid}_Enterprise_key_{AG-095410}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyota}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{7}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_January_2027}____[v3]_[01]_MTgwMDIzMDQwMDAwMA==46ac1b6b703b45287199e386ca8d5f25',
	TASK_MANAGER: 'https://taskmanager.qa.lios.toyota.com',
	AET: 'https://ts.stage.portal.toyotasupplier.com/aet',
	ALARMS: 'https://alarms.qa.lios.toyota.com',
	FORECAST_ADMIN_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/forecast',
	CO2: 'https://liosapps.qa.toyota.com/co2/lp-upload',
	COST_PLANNING: 'https://costplanning.qa.lios.toyota.com',
	EBOI: 'https://eboi.qa.lios.toyota.com',
	TLD: 'https://tld.qa.lios.toyota.com',
	DD: 'https://ts.stage.portal.toyotasupplier.com/lios/delayindex#/delayeddispatch',
	REPORTS: 'https://app.powerbi.com/Redirect?action=OpenApp&appId=11db23f6-28df-4b47-bf4d-03bb6cab9246&ctid=8c642d1d-d709-47b0-ab10-080af10798fb&experience=power-bi',
	EXPORT: 'https://export.qa.lios.toyota.com',
	GROUPI: 'https://liosapps.qa.toyota.com/groupi',
	SCHEDULE_JOB: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
	RETURNS_RELOAD: 'https://qa.lios.toyota.com/mshell/maintenance/returns-reload',
	SCHEDULE_DASHBOARD: 'https://ts.stage.portal.toyotasupplier.com/lios/jobScheduler',
	TLMS_SEND: 'https://ts.stage.portal.toyotasupplier.com/lios/tlmssend',
	ALLO: 'https://allo.qa.lios.toyota.com'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

